import * as libFund from './fund';
import { SEPARATOR, exactValidator, genericValidateName, uuidValidator } from './genericName';
const prefix = 'compositions';
const prefixWithSeparator = prefix + SEPARATOR;
export const IDToName = ({ fundID, compositionID }) => {
    return libFund.IDToName({ fundID }) + SEPARATOR + prefixWithSeparator + compositionID;
};
export const validateName = genericValidateName([
    exactValidator(libFund.prefix),
    uuidValidator(),
    exactValidator(prefix),
    uuidValidator(),
]);
export const nameToID = (name) => {
    validateName(name); // throws if invalid
    const parts = name.split(SEPARATOR);
    return {
        fundID: parts[1],
        compositionID: parts[3],
    };
};
